import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteHoliday } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import { invalidateHolidayQueries } from "./invalidate-holidays";

export function useDeleteHoliday() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (holidayId: string) =>
			deleteHoliday(activeCanteiroId as string, holidayId),
		onSuccess: () => invalidateHolidayQueries(queryClient),
	});
}
